var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import ChangeCompanyModal from '@/common/components/Modal/index.vue';
import { getAllCompanyList } from '@/views/company/api/index';
import MixinChangeStore from '@/common/mixins/changeStore';
import { getCookie, getStorage } from '@lhb/cache';
var CustomerService = /** @class */ (function (_super) {
    __extends(CustomerService, _super);
    function CustomerService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visible = false;
        return _this;
    }
    Object.defineProperty(CustomerService.prototype, "enterpriseList", {
        get: function () {
            return this.$store.state.common.companies || [];
        },
        enumerable: false,
        configurable: true
    });
    CustomerService.prototype.init = function () {
        var _this = this;
        this.visible = true;
        this.$nextTick(function () {
            if ((getCookie('newPmsToken') || getStorage('newPmsToken')) && !_this.enterpriseList.length) {
                getAllCompanyList().then(function (data) {
                    _this.$store.commit('UPDATE_COMPANIES', data);
                });
            }
        });
    };
    CustomerService.prototype.clickChangeCompany = function (id) {
        var _this = this;
        this.$store.commit('UPDATE_SCHEDULE_SEARCH_PARAMS', {
            status: '',
            occupationStatus: '',
            pattern: '1',
            startDate: '',
            endDate: '',
            searchPlaceName: '',
            categoryIds: [],
            cityIdList: [],
            labelIdList: [],
        });
        this.companyChange(id).then(function () {
            _this.$message.success('切换成功');
            _this.visible = false;
        });
    };
    CustomerService = __decorate([
        Component({
            components: {
                ChangeCompanyModal: ChangeCompanyModal
            },
            mixins: [MixinChangeStore],
        })
    ], CustomerService);
    return CustomerService;
}(Vue));
export default CustomerService;
